import React from "react";
import { toast } from "sonner";

/** CDN credential rotation via KMS (local Fernet · Vault Transit · AWS KMS). */
export default function KmsRotationPanel({ cdn, kmsBackends, rotations, rotating, revealedSecret, rotateCdnSecret, revealCdnSecret }) {
  return (
    <>
          {/* CDN credential rotation · KMS */}
          <div className="border-t border-zinc-800 pt-4" data-testid="cdn-rotation-section">
            <div className="flex items-baseline justify-between mb-2">
              <div>
                <div className="font-display font-bold">CDN credential rotation · KMS</div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">
                  {cdn.kms_backend} · {cdn.kms_key_id} · v{cdn.secret_version}
                  {" · available: "}
                  <span className="text-emerald-400">{kmsBackends.join(" · ")}</span>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <button
                  onClick={revealCdnSecret}
                  className="font-mono text-[10px] uppercase tracking-widest px-2 py-1 rounded-sm border border-zinc-700 text-zinc-300 hover:border-zinc-500"
                  data-testid="cdn-reveal-btn"
                >
                  Reveal current
                </button>
                <button
                  onClick={rotateCdnSecret}
                  disabled={rotating}
                  data-testid="cdn-rotate-btn"
                  className="font-mono text-[10px] uppercase tracking-widest px-3 py-1 rounded-sm border border-amber-500/60 text-amber-400 hover:bg-amber-500/10 disabled:opacity-40"
                >
                  {rotating ? "Rotating…" : "Rotate now"}
                </button>
              </div>
            </div>
            {revealedSecret && (
              <div className="border border-amber-500/50 bg-amber-950/30 rounded-sm p-2 font-mono text-[10px] mb-2" data-testid="cdn-revealed-panel">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-amber-300 uppercase tracking-widest">Plaintext secret · v{revealedSecret.version} · one-time</span>
                  <button
                    onClick={() => { navigator.clipboard.writeText(revealedSecret.secret); toast.success("Secret copied"); }}
                    className="text-amber-300 hover:text-amber-100"
                  >
                    Copy
                  </button>
                </div>
                <div className="text-amber-100 break-all">{revealedSecret.secret}</div>
                <div className="text-zinc-500 mt-1">
                  Revealed at {new Date(revealedSecret.revealed_at).toLocaleString([], { hour12: false })} · audit log recorded
                </div>
              </div>
            )}
            <div className="border border-zinc-800 rounded-sm bg-black/40 p-2" data-testid="cdn-rotations-history">
              <div className="text-[9px] text-zinc-500 uppercase tracking-widest mb-1">Rotation history · last 10</div>
              {rotations.length === 0 ? (
                <div className="text-xs text-zinc-500 italic">No rotations recorded yet.</div>
              ) : (
                <div className="space-y-0.5 max-h-32 overflow-y-auto scrollbar-thin font-mono text-[10px]">
                  {rotations.slice(0, 10).map((r) => (
                    <div key={r.id} className="flex items-center gap-2" data-testid={`rot-row-${r.id}`}>
                      <span className="text-emerald-400 w-12">v{r.new_secret_version}</span>
                      <span className="text-zinc-500 w-40">{new Date(r.rotated_at).toLocaleString([], { hour12: false })}</span>
                      <span className="text-zinc-300 w-24 truncate">{r.rotated_by}</span>
                      <span className="text-zinc-500 w-20">{r.kms_backend}</span>
                      <span className="text-zinc-400 flex-1 truncate">{r.reason}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

    </>
  );
}
